<template>
  <div class="main-intro">
    <div class="splashscreen-section-box">
        <div class="splashscreen-box img-box">
          <img src="@/assets/home/Maze-loop-201023.gif">  
        </div>
        <div class="splashscreen-box nav-box">
          <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" 
              viewBox="0 0 560  795" >
            <image  xlink:href="@/assets/home/blank.svg">
              <title>Menu</title>
            </image>
            <a xlink:href="/archiv">
              <rect x="0" y="0" fill="#eaeaea" opacity="0" width="795" height="200" />
            </a>
            <a xlink:href="/genese">
              <rect x="0" y="215" fill="#eaeaea" opacity="0" width="795" height="250" />
            </a>
            <a xlink:href="/text/0">
              <rect x="0" y="480" fill="#eaeaea" opacity="0" width="795" height="330" />
            </a>
          </svg>
         <!--<img src="@/assets/home/Home2.svg"> -->
        </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'Intro',
  components: {
  },
  methods: {
    //goto: function(target){
     // this.$router.push(target)
    //}
  }
}
</script>

<style lang="scss">
//@import "@/assets/css/textcommons.scss";
@import "@/assets/css/_variables.scss";
.navtoggler {
  display:block;
}

.main-intro {
  font-family: $font-family-herausgeber-regular ;
  color: black;
  .splashscreen-section-box {
    
    display: flex;
    height: calc( 100vh - 60px);
    .splashscreen-box {
      width: 50%;        
    }
    .splashscreen-box.img-box {
      margin-right: 15px;
      height: calc( 100vh - 60px);
      img {
          width:100%;
          height: 100%;
          object-fit: cover;
          @media screen and (max-width: 880px) {
            height: auto;
          }
        }
      }
    .splashscreen-box.nav-box {
      position: relative;
      margin-left: 15px;
      background: url('~@/assets/home/Home2.svg');
      background-repeat: no-repeat;
      background-size:contain;
      svg {
        display:block;
        height: 100%;
        object-fit: contain;  
        max-width: 100%;  
          rect {
            cursor: pointer;
          }
          @media (max-aspect-ratio: 795/560) {
              height: auto;
          }
      }
    }
  }
}
</style>